const HERO_THUMB_MAX_VISIBLE = 5;

function fitThumbsWidth(thumbsEl) {
  const slideEls = thumbsEl.querySelectorAll('.splide__slide');
  const visibleCount = Math.min(slideEls.length, HERO_THUMB_MAX_VISIBLE);
  if (visibleCount === 0) return;

  const firstSlide = slideEls[0];
  const slideWidth = firstSlide.offsetWidth;
  const trackEl = thumbsEl.querySelector('.splide__track');
  const listEl = thumbsEl.querySelector('.splide__list');

  const gap = listEl ? parseFloat(getComputedStyle(listEl).columnGap) || 0 : 0;
  const trackMarginLeft = trackEl ? parseFloat(getComputedStyle(trackEl).marginLeft) || 0 : 0;
  const trackMarginRight = trackEl ? parseFloat(getComputedStyle(trackEl).marginRight) || 0 : 0;

  const trackWidth = visibleCount * slideWidth + Math.max(0, visibleCount - 1) * gap;
  thumbsEl.style.maxWidth = trackWidth + trackMarginLeft + trackMarginRight + 'px';
}

function initHeroBanner(el) {
  if (el._heroBannerDestroy) return;

  const mainEl = el.querySelector('.hero-banner__main-splide');
  const thumbsEl = el.querySelector('.hero-banner__thumb-splide');

  if (!mainEl || typeof Splide === 'undefined') return;

  const speed = (parseFloat(el.style.getPropertyValue('--slide-speed')) || 5) * 1000;

  const mainSplide = new Splide(mainEl, {
    type: 'fade',
    rewind: true,
    autoplay: true,
    interval: speed,
    pauseOnHover: true,
    arrows: false,
    pagination: false,
  });

  let thumbsSplide = null;
  let ro = null;

  if (thumbsEl) {
    thumbsSplide = new Splide(thumbsEl, {
      rewind: true,
      pagination: false,
      isNavigation: true,
      // focus: 'center' + trimSpace: false だと1枚目が中央に寄り、左側に余白ができるため使わない
      fixedWidth: '12rem',
      gap: '0.8rem',
      breakpoints: {
        749: {
          fixedWidth: '8rem',
          gap: '0.5rem',
        },
      },
    });

    mainSplide.sync(thumbsSplide);
    mainSplide.mount();
    thumbsSplide.mount();

    thumbsSplide.on('ready', () => fitThumbsWidth(thumbsEl));

    ro = new ResizeObserver(() => fitThumbsWidth(thumbsEl, thumbsSplide));
    ro.observe(el);
  } else {
    mainSplide.mount();
  }

  el._heroBannerDestroy = () => {
    mainSplide.destroy();
    if (thumbsSplide) thumbsSplide.destroy();
    if (ro) ro.disconnect();
    delete el._heroBannerDestroy;
  };
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-banner]').forEach(initHeroBanner);
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-hero-banner]').forEach(initHeroBanner);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-hero-banner]').forEach((el) => {
    if (el._heroBannerDestroy) el._heroBannerDestroy();
  });
});
